    
namespace Serenity {

    /** Auto save types */
    export const enum AutoSaveOption {
        /** Never auto save */
        Never = 0,
        /** Automatically save pending changes without asking */
        Auto = 1,
        /** Ask for confirmation from user to save pending changes */
        Confirm = 2
    }

    @Serenity.Decorators.registerClass('Serenity.EntityGridDialog', [Serenity['IEditDialog']])
    export class EntityGridDialog<TItem, TOptions> extends Serenity.EntityGrid<TItem, TOptions> {

        protected tabs: JQuery;
        protected validator: JQueryValidation.Validator;
        protected idPrefix: string;
        protected dialogPane: JQuery;
        protected entity: TItem;
        protected entityId: any;
        protected propertyGrid: PropertyGrid;

        protected isDialogOpen: boolean;
        protected saveAndCloseButton: JQuery;
        protected applyChangesButton: JQuery;
        protected deleteButton: JQuery;
        protected undeleteButton: JQuery;
        protected cloneButton: JQuery;

        protected localizationGrid: PropertyGrid;
        protected localizationButton: JQuery;
        protected localizationPendingValue: any;
        protected localizationLastValue: any;
        protected loadedState: string;
        protected triedAutoSaveForCurrentEntity: boolean;

        constructor(container: JQuery, opt?: TOptions) {
            super(container, opt);

            this.element.on('ondatachange.' + this.uniqueName, () => {
                this.subDialogDataChange();
            });

            this.element.on('handleroute.' + this.uniqueName, (e, arg) => {
                if (arg.handled)
                    return;

                if (!arg.route && this.isDialogOpen) {
                    this.dialogClose();
                }
            });

            $(window).on('resize.' + this.uniqueName, () => {
                this.arrange();
            });
        }

        protected createSlickGrid() {
            var slickGrid = super.createSlickGrid();

            this.idPrefix = this.uniqueName + '_DLG_';

            this.element.addClass('s-GridWithDialog');

            this.dialogPane = $(`<div id="${this.uniqueName}_DLG" class="s-GridDialogPane flex-layout"></div>`)
                .appendTo(this.slickContainer);

            var widgetMarkup = this.getTemplate().replace(new RegExp('~_', 'g'), this.idPrefix);
            this.dialogPane.html(widgetMarkup);

            this.initValidator();
            this.initTabs();
            this.initPropertyGrid();
            this.initLocalizationGrid();
            return slickGrid;
        }

        public destroy(): void {

            $(window).off('resize.' + this.uniqueName);

            if (this.propertyGrid) {
                this.propertyGrid.destroy();
                this.propertyGrid = null;
            }

            if (this.localizationGrid) {
                this.localizationGrid.destroy();
                this.localizationGrid = null;
            }
            this.undeleteButton = null;
            this.applyChangesButton = null;
            this.deleteButton = null;
            this.saveAndCloseButton = null;
            this.tabs && this.tabs.tabs('destroy');
            this.tabs = null;
            this.validator && this.byId('Form').remove();
            this.validator = null;
            super.destroy();
        }

        protected getItemCssClass(item: TItem, index: number) {
            var klass = super.getItemCssClass(item, index);

            if (this.isDialogOpen && this.entityId == item[this.getIdProperty()]) {
                return (klass || "") + " editing-item";
            }

            return klass;
        }

        getSaveState() {
            try {
                return $.toJSON(this.getSaveEntity());
            }
            catch (e) {
                return null;
            }
        }

        protected hasPendingChanges() {
            return this.getSaveState() != this.loadedState;
        }

        protected autoSaveOnSwitch(): AutoSaveOption {
            return AutoSaveOption.Never;
        }

        protected autoSaveOnClose(): AutoSaveOption {
            return AutoSaveOption.Never;
        }

        protected checkPendingChangesOnSwitch(entityOrId: any, proceed: () => void) {
            if (this.isDialogOpen &&
                (typeof entityOrId == "number" || typeof entityOrId == "string")) {

                if (entityOrId == this.entityId)
                    return;

                if (this.autoSaveOnSwitch() && this.hasPendingChanges()) {

                    if (this.autoSaveOnSwitch() == AutoSaveOption.Confirm || this.triedAutoSaveForCurrentEntity) {
                        Q.confirm(Q.text("Site.Dialogs.PendingChangesConfirmation"),
                            () => {
                                this.save(response => {
                                    proceed();
                                });
                            },
                            {
                                onNo: () => {
                                    this.loadResponse({});
                                    proceed();
                                }
                            });
                    }
                    else {
                        this.triedAutoSaveForCurrentEntity = true;
                        this.save(response => {
                            proceed();
                        });
                    }

                    return;
                }
            }

            proceed();
        }

        protected editItem(entityOrId: any) {
            this.checkPendingChangesOnSwitch(entityOrId, () => {
                super.editItem(entityOrId);
            });
        }

        protected createEntityDialog(itemType: string, callback?: (dlg: Widget<any>) => void): Widget<any> {
            if (itemType == this.getItemType()) {
                callback && callback(this);
                return this;
            }

            return super.createEntityDialog(itemType, callback);
        }

        protected layout() {
            super.layout();
        }

        protected byId(id: string): JQuery {
            return $('#' + this.idPrefix + id);
        }

        private getDefaultTemplateName(): string {
            return Serenity.TemplatedDialog.prototype['getDefaultTemplateName'].call(this);
        }

        protected getTemplateName(): string {
            return Serenity.TemplatedDialog.prototype['getTemplateName'].call(this);
        }

        protected getFallbackTemplate(): string {
            return `<div class="s-DialogContent">
    <div class="s-Form">
        <form id="~_Form" action="">
            <div class="fieldset ui-widget ui-widget-content ui-corner-all">
                <div id="~_PropertyGrid"></div>
                <div class="clear"></div>
            </div>
        </form> 
    </div>
</div>`;
        }

        protected getTemplate(): string {
            return Serenity.TemplatedDialog.prototype['getTemplate'].call(this);
        }

        protected getValidatorOptions(): JQueryValidation.ValidationOptions {
            return {};
        }

        protected initValidator(): void {
            var form = this.byId('Form');
            if (form.length > 0) {
                var valOptions = this.getValidatorOptions();
                this.validator = form.validate(Q.validateOptions(valOptions));
            }
        }

        protected resetValidation() {
            this.validator && (this.validator as any).resetAll();
        }

        protected validateForm() {
            return this.validator == null || !!this.validator.form();
        }

        public dialogOpen(): void {
            if (!this.isDialogOpen) {
                this.element.toggleClass("dialog-open", true);
                this.isDialogOpen = true;
                this.updateInterface();
                this.layout();
                this.onDialogOpen();

                Q.Router.dialog(this.element, this.dialogPane, () => this.getEditHash());
                this.dialogPane.triggerHandler('panelopen');
            }
        }

        protected getEditHash() {
            if (this.entityId)
                return 'edit/' + this.entityId.toString();
            else
                return 'new';
        }

        protected onDialogOpen(): void {
            if (!$(document.body).hasClass('mobile-device'))
                $(':input', this.dialogPane).not('button').eq(0).focus();

            this.arrange();
            this.tabs && this.tabs.tabs('option', 'active', 0);
        }

        protected arrange(): void {
            if (window.innerWidth < 768) {
                this.dialogPane.children('.panel-titlebar')
                    .prependTo(this.element);
            }
            else {
                this.element.children('.panel-titlebar')
                    .prependTo(this.dialogPane);
            }

            this.dialogPane.find('.require-layout').filter(':visible').each(function (i, e) {
                $(e).triggerHandler('layout');
            });
        }

        protected onDialogClose() {
            $(document).trigger('click');

            if (($ as any).qtip) {
                $(document.body).children('.qtip').each(function (index, el) {
                    ($(el) as any).qtip('hide');
                });
            }
        }

        protected getDialogTitle() {
            return "";
        }

        public dialogClose(): void {
            if (this.isDialogOpen) {
                this.triedAutoSaveForCurrentEntity = false;
                this.element.toggleClass("dialog-open", false);
                this.isDialogOpen = false;
                this.updateInterface();
                this.layout();
                this.onDialogClose();
                this.dialogPane.triggerHandler('panelclose');
            }
        }

        public get dialogTitle(): string {
            return this.element.data('dialogtitle');
        }

        public set dialogTitle(value: string) {
            var oldTitle = this.dialogTitle;
            this.element.data('dialogtitle', value);
            if (oldTitle != this.dialogTitle) {
                this.setupDialogTitle();
                this.arrange();
            }
        }

        protected setupDialogTitle(): void {
            var value = Q.coalesce(this.dialogTitle, this.getDialogTitle());
            var pt = this.dialogPane.children('.panel-titlebar')
                .add(this.element.children('.panel-titlebar'));
            if (Q.isEmptyOrNull(value)) {
                pt.remove();
            }
            else {
                if (!pt.length) {
                    pt = $("<div class='panel-titlebar'><div class='panel-titlebar-text'></div></div>")
                        .prependTo(this.dialogPane);
                }
                pt.children('.panel-titlebar-text').text(value);
                if (!pt.children('.panel-titlebar-close').length) {
                    $('<button class="panel-titlebar-close">&nbsp;</button>')
                        .prependTo(pt)
                        .click(e => {
                            if (this.autoSaveOnClose() && this.hasPendingChanges()) {
                                e.preventDefault();

                                if (this.autoSaveOnClose() == AutoSaveOption.Confirm || this.triedAutoSaveForCurrentEntity) {
                                    Q.confirm(Q.text("Site.Dialogs.PendingChangesConfirmation"),
                                        () => this.saveAndCloseButton.click(),
                                        {
                                            onNo: () => {
                                                this.dialogClose();
                                            }
                                        });
                                }
                                else {
                                    this.triedAutoSaveForCurrentEntity = true;
                                    this.saveAndCloseButton.click();
                                }
                            }
                            else
                                this.dialogClose();
                        });
                }
            }
        }

        protected initTabs(): void {
            var tabsDiv = this.byId('Tabs');
            if (tabsDiv.length === 0) {
                return;
            }
            this.tabs = tabsDiv.tabs({});
            this.tabs.bind('tabsactivate', () => this.arrange());
        }

        protected get_entity(): TItem {
            return this.entity;
        }

        protected set_entity(entity: any): void {
            this.entity = entity || new Object();
        }

        protected get_entityId(): any {
            return this.entityId;
        }

        protected set_entityId(value: any) {
            this.entityId = value;
        }

        protected getEntityNameFieldValue(): any {
            return Q.coalesce(this.get_entity()[this.getNameProperty()], '').toString();
        }

        protected getEntityTitle(): string {
            if (!this.isEditMode()) {
                return Q.format(Q.text('Controls.EntityDialog.NewRecordTitle'), this.getEntitySingular());
            }
            else {
                var title = Q.coalesce(this.getEntityNameFieldValue(), '');
                return Q.format(Q.text('Controls.EntityDialog.EditRecordTitle'),
                    this.getEntitySingular(), (Q.isEmptyOrNull(title) ? '' : (' (' + title + ')')));
            }
        }

        protected updateTitle(): void {
            this.dialogTitle = this.getEntityTitle();
        }

        protected isCloneMode(): boolean {
            return false;
        }

        protected isEditMode(): boolean {
            return this.get_entityId() != null && !this.isCloneMode();
        }

        protected isDeleted(): boolean {
            if (this.get_entityId() == null) {
                return false;
            }

            var isDeletedProperty = this.getIsDeletedProperty();
            if (isDeletedProperty) {
                return !!this.get_entity()[isDeletedProperty];
            }

            var value = this.get_entity()[this.getIsActiveProperty()];
            if (value == null) {
                return false;
            }

            return value < 0;
        }

        protected isNew(): boolean {
            return this.get_entityId() == null;
        }

        protected isNewOrDeleted(): boolean {
            return this.isNew() || this.isDeleted();
        }

        protected getDeleteOptions(callback: (response: DeleteResponse) => void): ServiceOptions<DeleteResponse> {
            return {};
        }

        protected deleteHandler(options: ServiceOptions<DeleteResponse>, callback: (response: DeleteResponse) => void): void {
            Q.serviceCall(options);
        }

        protected doDelete(callback: (response: DeleteResponse) => void): void {
            var self = this;

            var request: DeleteRequest = {
                EntityId: this.get_entityId()
            };

            var baseOptions: Q.ServiceOptions<DeleteResponse> = {
                service: this.getService() + '/Delete',
                request: request,
                onSuccess: response => {
                    self.onDeleteSuccess(response);
                    if (callback != null) {
                        callback(response);
                    }
                    self.element.triggerHandler('ondatachange', [{
                        entityId: request.EntityId,
                        entity: this.entity,
                        type: 'delete'
                    }]);
                }
            };

            var thisOptions = this.getDeleteOptions(callback);
            var finalOptions = $.extend(baseOptions, thisOptions);

            this.deleteHandler(finalOptions, callback);
        }

        protected onDeleteSuccess(response: DeleteResponse): void {
        }

        protected attrs<TAttr>(attrType: { new(...args: any[]): TAttr }): TAttr[] {
            return Q.getAttributes(Q.getInstanceType(this), attrType, true);
        }

        protected getEntityType(): string {

            var name = super.getEntityType();
            if (Q.endsWith(name, 'Grid')) {
                this['entityType'] = name = name.substr(0, name.length - 4);
            }

            return name;
        }

        private formKey: string;

        protected getFormKey(): string {
            if (this.formKey != null)
                return this.formKey;

            var attributes = this.attrs(FormKeyAttribute);

            if (attributes.length >= 1)
                return (this.formKey = attributes[0].value);

            return (this.formKey = this.getEntityType());
        }

        private entitySingular: string;

        protected getEntitySingular(): string {
            if (this.entitySingular != null)
                return this.entitySingular;

            var attributes = this.attrs(ItemNameAttribute);

            if (attributes.length >= 1) {
                this.entitySingular = attributes[0].value;
                this.entitySingular = Q.LT.getDefault(this.entitySingular, this.entitySingular);
            }
            else {
                var es = Q.tryGetText(this.getLocalTextDbPrefix() + 'EntitySingular');
                if (es == null)
                    es = this.getEntityType();
                this.entitySingular = es;
            }

            return this.entitySingular;
        }

        private nameProperty: string;

        protected getNameProperty(): string {
            if (this.nameProperty != null)
                return this.nameProperty;

            var attributes = this.attrs(NamePropertyAttribute);

            if (attributes.length >= 1)
                this.nameProperty = attributes[0].value;
            else
                this.nameProperty = 'Name';

            return this.nameProperty;
        }

        protected getIsDeletedProperty(): string {
            return null;
        }

        load(entityOrId: any, done: () => void, fail: (ex: any) => void): void {

            var action = () => {

                if (entityOrId == null) {
                    this.loadResponse({});
                    done && done();
                    return;
                }

                var scriptType = typeof (entityOrId);
                if (scriptType === 'string' || scriptType === 'number') {
                    var entityId = entityOrId;

                    this.loadById(entityId, function (response) {
                        if (done)
                            window.setTimeout(done, 0);
                    }, null);

                    return;
                }

                var entity = entityOrId || new Object();
                this.loadResponse({ Entity: entity });
                done && done();
            };

            if (fail == null) {
                action();
                return;
            }

            try {
                action();
            }
            catch (ex) {
                fail(ex);
            }
        }

        loadNewAndOpenDialog(): void {
            this.loadResponse({});
            this.dialogOpen();
        }

        loadEntityAndOpenDialog(entity: TItem, asPanel?: boolean): void {
            this.loadResponse({ Entity: entity });
            this.dialogOpen();
        }

        protected loadResponse(data: any): void {
            var oldEntityId = this.entityId;
            data = data || {};
            this.onLoadingData(data);
            var entity = data.Entity || new Object();
            this.beforeLoadEntity(entity);
            this.loadEntity(entity);
            this.set_entity(entity);
            this.afterLoadEntity();
            if (this.isDialogOpen && oldEntityId != this.entityId)
                Q.Router.replaceLast(this.getEditHash(), true);

            if (this.autoSaveOnClose() ||
                this.autoSaveOnSwitch()) {
                this.triedAutoSaveForCurrentEntity = false;
                this.loadedState = this.getSaveState();
            }
        }

        protected loadEntity(entity: TItem): void {
            var idField = this.getIdProperty();

            if (idField != null)
                this.set_entityId(entity[idField]);

            this.set_entity(entity);

            if (this.propertyGrid != null) {
                this.propertyGrid.set_mode((this.isEditMode() ?
                    PropertyGridMode.update : PropertyGridMode.insert));
                this.propertyGrid.load(entity);
            }
        }

        protected beforeLoadEntity(entity: TItem): void {
            this.localizationPendingValue = null;
            this.localizationLastValue = null;
        }

        protected afterLoadEntity(): void {
            this.updateInterface();
            this.updateTitle();
            this.slickGrid.invalidate();
        }

        public loadByIdAndOpenDialog(entityId: any) {
            this.loadById(entityId,
                response => window.setTimeout(() => this.dialogOpen(), 0),
                () => {
                    if (!this.element.is(':visible')) {
                        this.element.remove();
                    }
                });
        }

        protected onLoadingData(data: RetrieveResponse<TItem>): void {
        }

        protected getLoadByIdOptions(id: any, callback: (response: RetrieveResponse<TItem>) => void): ServiceOptions<RetrieveResponse<TItem>> {
            return {};
        }

        protected getLoadByIdRequest(id: any): RetrieveRequest {
            var request: RetrieveRequest = {};
            request.EntityId = id;
            return request;
        }

        protected reloadById(): void {
            this.loadById(this.get_entityId());
        }

        loadById(id: any, callback?: (response: RetrieveResponse<TItem>) => void, fail?: () => void) {
            var baseOptions: Q.ServiceOptions<RetrieveResponse<TItem>> = {
                service: this.getService() + '/Retrieve',
                blockUI: true,
                request: this.getLoadByIdRequest(id),
                onSuccess: response => {
                    this.loadResponse(response);
                    callback && callback(response);
                },
                onCleanup: () => {
                    if (this.validator != null) {
                        Q.validatorAbortHandler(this.validator);
                    }
                }
            };

            var thisOptions = this.getLoadByIdOptions(id, callback);
            var finalOptions = $.extend(baseOptions, thisOptions);
            this.loadByIdHandler(finalOptions, callback, fail);
        }

        protected loadByIdHandler(options: ServiceOptions<RetrieveResponse<TItem>>, callback: (response: RetrieveResponse<TItem>) => void, fail: () => void): void {
            var request = Q.serviceCall(options);
            fail && request.fail(fail);
        }

        protected initLocalizationGrid(): void {
            var pgDiv = this.byId('PropertyGrid');
            if (pgDiv.length <= 0) {
                return;
            }
            var pgOptions = this.getPropertyGridOptions();
            this.initLocalizationGridCommon(pgOptions);
        }

        protected initLocalizationGridCommon(pgOptions: PropertyGridOptions) {
            var pgDiv = this.byId('PropertyGrid');

            if (!Q.any(pgOptions.items, x => x.localizable === true))
                return;

            var localGridDiv = $('<div/>')
                .attr('id', this.idPrefix + 'LocalizationGrid')
                .hide().insertAfter(pgDiv);

            pgOptions.idPrefix = this.idPrefix + 'Localization_';

            var items: PropertyItem[] = [];
            for (var item1 of pgOptions.items) {
                var langs = null;

                if (item1.localizable === true) {
                    var copy = $.extend({}, item1) as any;
                    copy.oneWay = true;
                    copy.readOnly = true;
                    copy.required = false;
                    copy.defaultValue = null;
                    items.push(copy);

                    if (langs == null)
                        langs = this.getLangs();

                    for (var lang of langs) {
                        copy = $.extend({}, item1);
                        copy.name = lang[0] + '$' + copy.name;
                        copy.title = lang[1];
                        copy.cssClass = [copy.cssClass, 'translation'].join(' ');
                        copy.insertable = true;
                        copy.updatable = true;
                        copy.oneWay = false;
                        copy.required = false;
                        copy.localizable = false;
                        copy.defaultValue = null;
                        items.push(copy);
                    }
                }
            }

            pgOptions.items = items;

            this.localizationGrid = (new Serenity.PropertyGrid(localGridDiv, pgOptions)).init(null);
            localGridDiv.addClass('s-LocalizationGrid');
        }

        protected isLocalizationMode(): boolean {
            return this.localizationButton != null && this.localizationButton.hasClass('pressed');
        }

        protected isLocalizationModeAndChanged(): boolean {
            if (!this.isLocalizationMode()) {
                return false;
            }

            var newValue = this.getLocalizationGridValue();
            return $.toJSON(this.localizationLastValue) != $.toJSON(newValue);
        }

        protected localizationButtonClick(): void {
            if (this.isLocalizationMode() && !this.validateForm()) {
                return;
            }

            if (this.isLocalizationModeAndChanged()) {
                var newValue = this.getLocalizationGridValue();
                this.localizationLastValue = newValue;
                this.localizationPendingValue = newValue;
            }

            this.localizationButton.toggleClass('pressed');
            this.updateInterface();
            if (this.isLocalizationMode()) {
                this.loadLocalization();
            }
        }

        protected getLanguages(): any[] {
            if (Serenity.EntityDialog.defaultLanguageList != null)
                return Serenity.EntityDialog.defaultLanguageList() || [];

            return [];
        }

        // for compatibility with older getLanguages methods written in Saltaralle
        private getLangs(): any {

            var langsTuple = this.getLanguages();
            var langs = Q.safeCast(langsTuple, Array);
            if (langs == null || langs.length === 0 ||
                langs[0] == null || !Q.isArray(langs[0])) {
                langs = Array.prototype.slice.call(langsTuple.map(function (x: any) {
                    return [x.item1, x.item2];
                }));
            }

            return langs;
        }

        protected loadLocalization(): void {
            if (this.localizationLastValue == null && this.isNew()) {
                this.localizationGrid.load({});
                this.setLocalizationGridCurrentValues();
                this.localizationLastValue = this.getLocalizationGridValue();
                return;
            }

            if (this.localizationLastValue != null) {
                this.localizationGrid.load(this.localizationLastValue);
                this.setLocalizationGridCurrentValues();
                return;
            }

            var opt = <Q.ServiceOptions<any>>{
                service: this.getService() + '/Retrieve',
                blockUI: true,
                request: {
                    EntityId: this.get_entityId(),
                    ColumnSelection: 'keyOnly',
                    IncludeColumns: ['Localizations']
                },
                onSuccess: response => {
                    var copy = $.extend(new Object(), this.get_entity());
                    if (response.Localizations) {
                        for (var language of Object.keys(response.Localizations)) {
                            var entity = response.Localizations[language];
                            for (var key of Object.keys(entity)) {
                                copy[language + '$' + key] = entity[key];
                            }
                        }
                    }

                    this.localizationGrid.load(copy);
                    this.setLocalizationGridCurrentValues();
                    this.localizationPendingValue = null;
                    this.localizationLastValue = this.getLocalizationGridValue();
                }
            };

            Q.serviceCall(opt);
        }

        protected setLocalizationGridCurrentValues(): void {
            var valueByName = {};

            this.localizationGrid.enumerateItems((item, widget) => {
                if (item.name.indexOf('$') < 0 && widget.element.is(':input')) {
                    valueByName[item.name] = this.byId(item.name).val();
                    widget.element.val(valueByName[item.name]);
                }
            });

            this.localizationGrid.enumerateItems((item1, widget1) => {
                var idx = item1.name.indexOf('$');
                if (idx >= 0 && widget1.element.is(':input')) {
                    var hint = valueByName[item1.name.substr(idx + 1)];
                    if (hint != null && hint.length > 0) {
                        widget1.element.attr('title', hint).attr('placeholder', hint);
                    }
                }
            });
        }

        protected getLocalizationGridValue(): any {
            var value = {};
            this.localizationGrid.save(value);

            for (var k of Object.keys(value)) {
                if (k.indexOf('$') < 0) {
                    delete value[k];
                }
            }

            return value;
        }

        protected getPendingLocalizations(): any {
            if (this.localizationPendingValue == null) {
                return null;
            }

            var result: Q.Dictionary<any> = {};
            var idField = this.getIdProperty();
            var langs = this.getLangs();

            for (var pair of langs) {
                var language = pair[0];
                var entity: any = {};

                if (idField != null) {
                    entity[idField] = this.get_entityId();
                }

                var prefix = language + '$';

                for (var k of Object.keys(this.localizationPendingValue)) {
                    if (Q.startsWith(k, prefix))
                        entity[k.substr(prefix.length)] = this.localizationPendingValue[k];
                }

                result[language] = entity;
            }

            return result;
        }

        protected initPropertyGrid(): void {
            var pgDiv = this.byId('PropertyGrid');
            if (pgDiv.length <= 0) {
                return;
            }
            var pgOptions = this.getPropertyGridOptions();
            this.propertyGrid = (new Serenity.PropertyGrid(pgDiv, pgOptions)).init(null);
            if (this.element.closest('.ui-dialog').hasClass('s-Flexify')) {
                this.propertyGrid.element.children('.categories').flexHeightOnly(1);
            }
        }

        protected getFormPropertyItems() {
            var formKey = this.getFormKey();
            return Q.getForm(formKey);
        }

        protected getPropertyGridOptions(): PropertyGridOptions {
            return {
                idPrefix: this.idPrefix,
                items: this.getFormPropertyItems(),
                mode: PropertyGridMode.insert,
                localTextPrefix: 'Forms.' + this.getFormKey() + '.',
                useCategories: true
            };
        }

        protected validateBeforeSave(): boolean {
            return true;
        }

        protected getSaveOptions(callback: (response: SaveResponse) => void): ServiceOptions<SaveResponse> {

            var opt: Q.ServiceOptions<SaveResponse> = {};

            opt.service = this.getService() + '/' + (this.isEditMode() ? 'Update' : 'Create'),

                opt.onSuccess = response => {
                    this.triedAutoSaveForCurrentEntity = false;
                    this.onSaveSuccess(response);

                    callback && callback(response);

                    var typ = (this.isEditMode() ? 'update' : 'create');

                    var ent = opt.request == null ? null : opt.request.Entity;
                    var eid: any = this.isEditMode() ? this.get_entityId() :
                        (response == null ? null : response.EntityId);

                    var dci = {
                        type: typ,
                        entity: ent,
                        entityId: eid
                    };

                    this.element.triggerHandler('ondatachange', [dci]);
                };

            opt.onCleanup = () => {
                this.validator && Q.validatorAbortHandler(this.validator);
            };

            opt.request = this.getSaveRequest();

            return opt;
        }

        protected getSaveEntity(): TItem {

            var entity: TItem = new Object() as any;

            if (this.propertyGrid != null) {
                this.propertyGrid.save(entity);
            }

            if (this.isEditMode()) {
                var idField = this.getIdProperty();
                if (idField != null && entity[idField] == null) {
                    entity[idField] = this.get_entityId();
                }
            }

            return entity;
        }

        protected getSaveRequest(): SaveRequest<TItem> {

            var entity = this.getSaveEntity();
            var req: SaveRequest<TItem> = {};
            req.Entity = entity;

            if (this.isEditMode()) {
                var idField = this.getIdProperty();
                if (idField != null) {
                    req.EntityId = this.get_entityId();
                }
            }

            if (this.localizationPendingValue != null) {
                req.Localizations = this.getPendingLocalizations();
            }

            return req;
        }

        protected onSaveSuccess(response: SaveResponse): void {
        }

        protected save_submitHandler(callback: (response: SaveResponse) => void): void {
            var options = this.getSaveOptions(callback);
            this.saveHandler(options, callback);
        }

        protected save(callback?: (response: SaveResponse) => void): void | boolean {
            return Serenity.ValidationHelper.submit(this.byId('Form'),
                () => this.validateBeforeSave(),
                () => this.save_submitHandler(callback));
        }

        protected saveHandler(options: ServiceOptions<SaveResponse>,
            callback: (response: SaveResponse) => void): void {
            Q.serviceCall(options);
        }

        protected createToolbar(buttons: ToolButton[]) {

            super.createToolbar(buttons);

            if (!this.toolbar)
                return;

            this.saveAndCloseButton = this.toolbar.findButton('save-and-close-button').hide();
            this.saveAndCloseButton.prev('.separator').addClass('dialog-button-separator');
            this.applyChangesButton = this.toolbar.findButton('apply-changes-button').hide();
            this.deleteButton = this.toolbar.findButton('delete-button').hide();
            this.undeleteButton = this.toolbar.findButton('undo-delete-button').hide();
            this.cloneButton = this.toolbar.findButton('clone-button').hide();
            this.localizationButton = this.toolbar.findButton('localization-button').hide();
        }

        protected showSaveSuccessMessage(response: SaveResponse): void {
            Q.notifySuccess(Q.text('Controls.EntityDialog.SaveSuccessMessage'), '', null);
        }

        protected getButtons(): ToolButton[] {

            var list = super.getButtons();

            list.push({
                title: Q.text('Controls.EntityDialog.SaveButton'),
                cssClass: 'save-and-close-button dialog-button',
                hotkey: 'alt+s',
                separator: true,
                onClick: () => {
                    this.save(response => {
                        this.dialogClose();
                    });
                }
            });

            list.push({
                title: '',
                hint: Q.text('Controls.EntityDialog.ApplyChangesButton'),
                cssClass: 'apply-changes-button dialog-button',
                hotkey: 'alt+a',
                onClick: () => {
                    this.save(response1 => {

                        if (this.isEditMode()) {
                            var id1 = response1.EntityId;
                            if (id1 == null) {
                                id1 = this.get_entityId();
                            }
                            this.loadById(id1);
                        }
                        else {
                            this.loadById(response1.EntityId);
                        }

                        this.showSaveSuccessMessage(response1);
                    });
                }
            });

            list.push({
                title: Q.text('Controls.EntityDialog.DeleteButton'),
                cssClass: 'delete-button dialog-button',
                hotkey: 'alt+x',
                onClick: () => {
                    Q.confirm(Q.text('Controls.EntityDialog.DeleteConfirmation'), () => {
                        this.doDelete(() => this.dialogClose());
                    });
                }
            });

            list.push({
                title: Q.text('Controls.EntityDialog.UndeleteButton'),
                cssClass: 'undo-delete-button dialog-button',
                onClick: () => {
                    if (this.isDeleted()) {
                        Q.confirm(Q.text('Controls.EntityDialog.UndeleteConfirmation'), () => {
                            this.undelete(() => this.loadById(this.get_entityId()));
                        });
                    }
                }
            });

            list.push({
                title: Q.text('Controls.EntityDialog.LocalizationButton'),
                cssClass: 'localization-button dialog-button',
                onClick: () => this.localizationButtonClick()
            });

            list.push({
                title: Q.text('Controls.EntityDialog.CloneButton'),
                cssClass: 'clone-button dialog-button',
                onClick: () => {

                    if (!this.isEditMode()) {
                        return;
                    }

                    var cloneEntity = this.getCloningEntity();

                    Serenity.Widget.create({
                        type: Q.getInstanceType(this),
                        init: w => Serenity.SubDialogHelper.bubbleDataChange(
                            Serenity.SubDialogHelper.cascade(w, this.element), this, true)
                            .loadEntityAndOpenDialog(cloneEntity, null)
                    });
                }
            });

            return list;
        }

        protected getCloningEntity(): TItem {

            var clone: TItem = new Object() as any;
            clone = $.extend(clone, this.get_entity());

            var idField = this.getIdProperty();
            if (!Q.isEmptyOrNull(idField)) {
                delete clone[idField];
            }

            var isActiveField = this.getIsActiveProperty();
            if (!Q.isEmptyOrNull(isActiveField)) {
                delete clone[isActiveField];
            }

            var isDeletedField = this.getIsDeletedProperty();
            if (!Q.isEmptyOrNull(isDeletedField)) {
                delete clone[isDeletedField];
            }

            return clone;
        }

        protected updateInterface(): void {

            var isOpen = this.isDialogOpen;
            var isDeleted = this.isDeleted();
            var isLocalizationMode = this.isLocalizationMode();

            if (this.tabs != null) {
                Serenity.TabsExtensions.setDisabled(this.tabs, 'Log', !isOpen || this.isNewOrDeleted());
            }

            if (this.propertyGrid != null) {
                this.propertyGrid.element.toggle(isOpen && !isLocalizationMode);
            }

            if (this.localizationGrid != null) {
                this.localizationGrid.element.toggle(isOpen && isLocalizationMode);
            }

            if (this.localizationButton != null) {
                this.localizationButton.toggle(this.localizationGrid != null);
                this.localizationButton.find('.button-inner')
                    .text((this.isLocalizationMode() ?
                        Q.text('Controls.EntityDialog.LocalizationBack') :
                        Q.text('Controls.EntityDialog.LocalizationButton')));
            }

            if (isLocalizationMode && isOpen) {

                if (this.toolbar != null)
                    this.toolbar.findButton('tool-button')
                        .not('.localization-hidden')
                        .addClass('.localization-hidden').hide();

                this.localizationButton && this.localizationButton.show();

                return;
            }

            this.toolbar.findButton('localization-hidden')
                .removeClass('localization-hidden').show();

            this.deleteButton && this.deleteButton.toggle(isOpen && this.isEditMode() && !isDeleted);
            this.undeleteButton && this.undeleteButton.toggle(isOpen && this.isEditMode() && isDeleted);

            if (this.saveAndCloseButton) {
                this.saveAndCloseButton.toggle(isOpen && !isDeleted);
                this.saveAndCloseButton.find('.button-inner')
                    .text(Q.text((this.isNew() ? 'Controls.EntityDialog.SaveButton' :
                        'Controls.EntityDialog.UpdateButton')));
            }

            this.applyChangesButton && this.applyChangesButton.toggle(isOpen && !isDeleted);
            this.cloneButton && this.cloneButton.toggle(false);
        }

        protected getUndeleteOptions(callback?: (response: UndeleteResponse) => void): ServiceOptions<UndeleteResponse> {
            return {}
        }

        protected undeleteHandler(options: ServiceOptions<UndeleteResponse>, callback: (response: UndeleteResponse) => void): void {
            Q.serviceCall(options);
        }

        protected undelete(callback?: (response: UndeleteResponse) => void): void {
            var baseOptions: Q.ServiceOptions<UndeleteResponse> = {};
            baseOptions.service = this.getService() + '/Undelete';

            var request: UndeleteRequest = {};
            request.EntityId = this.get_entityId();

            baseOptions.request = request;
            baseOptions.onSuccess = response => {
                callback && callback(response);
                this.element.triggerHandler('ondatachange', [{
                    entityId: this.get_entityId(),
                    entity: this.entity,
                    type: 'undelete'
                }]);
            };

            var thisOptions = this.getUndeleteOptions(callback);
            var finalOptions = $.extend(baseOptions, thisOptions);
            this.undeleteHandler(finalOptions, callback);
        }
    }
}